<template>
  <div ref="root" class="dfl" :class="{ 'dfl--mobile': isMobile }">
    <div class="dfl__section">{{ $t('taskDeskFilterPeople') }}</div>
    <div class="dfl__grid">
      <status v-model="desk.taskStatus" :hideconfig="true" :multiple="true" />
      <tag v-model="desk.tag" />
      <desk-picker v-model="desk.functor" title="functor" :height="fieldH" type="partners" />
      <desk-picker v-model="desk.registerar" title="registerar" :height="fieldH" type="partners" />
      <desk-picker v-model="desk.participants" title="participants" :height="fieldH" type="partners" :multiple="true" />
    </div>

    <template v-for="r in ranges">
      <div :key="r.id + 's'" class="dfl__section">{{ $t(r.label) }}</div>
      <div :key="r.id + 'g'" class="dfl__grid dfl__grid--2">
        <div v-for="f in r.fields" :key="f.model" class="dfl__date">
          <v-text-field
            :id="'tdf-' + f.model"
            v-model="desk[f.model]"
            :label="$t(f.prefix) + ' ' + $t(r.label)"
            append-icon="mdi-calendar-blank-outline"
            outlined
            dense
            clearable
            hide-details
          />
          <date-picker
            v-model="desk[f.model]"
            :element="'tdf-' + f.model"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            :min="f.min ? desk[f.min] : undefined"
            auto-submit
            :color="primaryColor"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import DeskPicker from '../../setting/components/SettingAccountPicker'

export default {
  name: 'DeskFilters',
  components: {
    DeskPicker,
    Tag: () => import('../../../components/general/Tag/tag'),
    Status: () => import('../../../components/general/Status/status'),
  },
  inject: ['desk'],
  data () {
    return { fieldH: 40 }
  },
  mounted () {
    // Match the pickers to the height of the other fields (tag/status/date).
    this.syncHeight()
    setTimeout(this.syncHeight, 400)
  },
  methods: {
    syncHeight () {
      const slot = this.$refs.root && this.$refs.root.querySelector('.dfl__grid > :nth-child(2) .v-input__slot') ||
        this.$refs.root.querySelector('.dfl__date .v-input__slot')
      const h = slot && slot.offsetHeight // offsetHeight ignores the dialog's scale transition
      if (h && h >= 28 && h <= 56) this.fieldH = h
    },
  },
  computed: {
    ranges () {
      return [
        { id: 'c', label: 'createDate', fields: [{ model: 'fromDate', prefix: 'from' }, { model: 'toDate', prefix: 'until', min: 'fromDate' }] },
        { id: 'u', label: 'dateUpdate', fields: [{ model: 'fromDateUpdate', prefix: 'from' }, { model: 'toDateUpdate', prefix: 'until', min: 'fromDateUpdate' }] },
        { id: 'd', label: 'dueDate', fields: [{ model: 'fromDueDate', prefix: 'from' }, { model: 'toDueDate', prefix: 'until', min: 'fromDueDate' }] },
      ]
    },
    primaryColor () {
      return this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary
    },
  },
}
</script>

<style scoped>
.dfl__section {
  font-size: 0.78rem;
  font-weight: 700;
  color: #6b7280;
  margin: 16px 0 10px;
}
.dfl__section:first-child {
  margin-top: 0;
}
.dfl__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  align-items: start;
}
.dfl__grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.dfl--mobile .dfl__grid {
  grid-template-columns: minmax(0, 1fr);
}
.dfl--mobile .dfl__grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.dfl ::v-deep .v-input {
  height: auto !important;
}
.dfl ::v-deep .v-text-field__details {
  display: none;
}
.dfl ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}
</style>
